import { PickListSelectionType } from "~/enums/pickListSelectionType"
import { IObjectModelProperty } from '~/interfaces/objectModelInterfaces'

export enum ObjectModelPropertyRootType {
  Text = 1,
  LongText = 2,
  PickList = 3,
  Number = 4,
  DateTime = 5,
  MappedProperty = 6,
  RelationshipCount = 7,
  DerivedField = 8,
  AutoIncrement = 9,
  FileAttachment = 10,
  Aggregate = 11,
  Section = 12,
}

export enum ObjectModelPropertyChildType {
  PickListOption = 31,
}

const ObjectModelPropertyRootTypeName = {
  [ObjectModelPropertyRootType.Text]: 'Text',
  [ObjectModelPropertyRootType.LongText]: 'Long Text',
  [ObjectModelPropertyRootType.PickList]: 'Pick List',
  [ObjectModelPropertyRootType.Number]: 'Number',
  [ObjectModelPropertyRootType.DateTime]: 'Date Time',
  [ObjectModelPropertyRootType.MappedProperty]: 'Mapped Property',
  [ObjectModelPropertyRootType.RelationshipCount]: 'Relationship Count',
  [ObjectModelPropertyRootType.DerivedField]: 'Derived Field',
  [ObjectModelPropertyRootType.AutoIncrement]: 'Auto Increment',
  [ObjectModelPropertyRootType.FileAttachment]: 'File Attachment',
  [ObjectModelPropertyRootType.Aggregate]: 'Aggregate',
  [ObjectModelPropertyRootType.Section]: 'Section',
};

export type ObjectModelPropertyType = ObjectModelPropertyRootType | ObjectModelPropertyChildType;

export function ObjectModelPropertyName(omp: IObjectModelProperty | ObjectModelPropertyType): string {
  if (typeof (omp) === 'number') {
    return ObjectModelPropertyRootTypeName[omp]
  } else if ((omp?.property_type === ObjectModelPropertyRootType.PickList) && (omp?.selection_type === PickListSelectionType.MultiSelect)) {
    return 'Multi-Pick List'
  } else {
    return ObjectModelPropertyRootTypeName[omp.property_type]
  }
}
